import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Typography,
  Checkbox,
  Box,
} from "@mui/material";
import { editGuestDetail, getSalesOrderDetail, returnUpdate } from "../actions";
import Header from "../Components/header";
import NavigationButtons from "../Components/navigationButton";
import SummaryContent from "../Components/summary";
import { withTranslation } from "react-i18next";

const { URL_PREFIX } = window;

class VF2StepSummary extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      isGetDataLoading: false,
      isOpen: false,
      form: {
        isAgreed: false, // Added checkbox state to form
      },
    };
  }

  componentWillMount() {
  }

  handleCheckboxChange = (event) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        isAgreed: event.target.checked,
      },
    }));
  };

  handleSubmit = async (type) => {
    const { isAgreed } = this.state.form;
    if (isAgreed) {
      this.setState({ isLoading: true });
      try {
        const {guestDetail} = this.props.vf2
        if(type === 'next'){
          await this.props.editGuestDetail({
            Guest_Visit_Form_2_Status__c: 'Completed',
            lang__c: this.props.i18n.language
          }, guestDetail.Id, this.props.returnUpdate, 'detail');
        }
      } catch (error) {
        console.error(this.props.t('Error saving guest:'), error);
      } finally {
        this.setState({ isLoading: false });
      }
    } else {
      alert(this.props.t("You must agree to the privacy terms and conditions before submitting."));
      return false
    }
  };

  render() {
    const { guestDetail = {}, agentDetail } = this.props.vf2;
    const { isAgreed } = this.state.form;

    return (
      <>
        <div style={{ margin: "30px", position: 'relative' }}>
          <Header 
            title={this.props.t("Summary")}
            subtitle={this.props.t("Please check your visit form summary before submission")}
            selectedGuest={guestDetail}
            agent={agentDetail}
          />
          <SummaryContent guestDetail={guestDetail} />

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              checked={isAgreed}
              onChange={this.handleCheckboxChange}
              sx={{
                color: '#5165D6',
                transform: 'scale(1.5)', // Makes the checkbox bigger
              }}
            />
            <Typography
              component="span"
              sx={{
                fontSize: '18px', // Increases the font size
                color: '#344054',
              }}
            >
              {this.props.t("I agree with the")}{' '}
              <a
                href="https://www.wakatobi.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontSize: '18px',
                  color: '#5165D6',
                }}
              >
                {this.props.t("privacy terms and conditions")}
              </a>.
            </Typography>
          </Box>

          <NavigationButtons 
            nextUrl={`${URL_PREFIX}/vf2/wizard/finish`} 
            backUrl={`${URL_PREFIX}/vf2/wizard/flight`} 
            onSave={this.handleSubmit}  // Use handleSubmit for the save action
            isLoading={this.state.isLoading} 
            showSave={false}
            showBack
            showNext
            customNextText={this.props.t('Submit')}
            nextDisabled={!isAgreed} // Disable the button if not agreed
          />
        </div>
      </>
    );
  }
}

VF2StepSummary.propTypes = {
  vf2: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSalesOrderDetail,
      editGuestDetail,
      returnUpdate
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VF2StepSummary));